import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import copy from "copy-to-clipboard";
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import Modal from 'react-modal';
import CloseIcon from '@images/owner/close.svg';
import CopyIcon from '@images/owner/content_copy.svg';
import DollerIcon from '@images/owner/attach_money.svg';

const ShareDiscountCouponModal = () => {
    const modal = useModal();
    const [linkColor, setLinkColor] = useState('#000');
    const user = useSelector((state) => state?.setUserDetails?.user);

    const copyToCodeHandler = () => {
        copy(`https://shop.frodobots.com/pages/sharediscount?coupon=${user.referral_code}&botype=minip`)
        setLinkColor('#008735')
    }

    const closeModal = () => {
        modal.hide();
        setLinkColor('#000')
    }

    return (
        <Modal
            isOpen={modal.visible}
            ariaHideApp={false}
            className="mymodal"
            onRequestClose={closeModal}
        >
            <div className="flex w-[800px] p-[16px] flex-col items-start gap-[16px] rounded-[32px] bg-[#F1F1F1] overflow-y-auto max-h-[230px] h-full">
                <div className="w-full flex px-[16px] py-[6px] justify-between items-center rounded-[16px]">
                    <p className="text-[#000] ml-[33.33%] text-center text-[28px] not-italic font-semibold leading-[28px] tracking-[-1.68px]">
                        Share discount code
                    </p>
                    <button onClick={closeModal}>
                        <img src={CloseIcon} alt="Close Icon" className='w-[24px] h-[24px]' />
                    </button>
                </div>
                <div className='w-full flex p-[12px] items-center gap-[13px] rounded-[12px] border-[1px] border-[solid] border-[#DDD] bg-[#F3F3F3]'>
                    <div className='w-full flex flex-col justify-center items-start gap-[16px]'>
                        <div className='flex pb-[16px] items-center gap-[8px] border-b-[1px] border-b-solid border-b-[#EBEBEB]'>
                            <div className='flex p-[8px] items-center gap-[10px] rounded-[24px] bg-[#25BD66]'>
                                <img src={DollerIcon} alt="Doller Icon" className='w-[24px] h-[24px]' />
                            </div>
                            <div className='flex flex-col justify-center items-start gap-[4px]'>
                                <p className='text-[#25BD66] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Give a discount to your friends for 250 FBP!</p>
                                <p className='text-[#4B4B4B] text-[14px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Your code can give your friends a $50 discount on their first Earth Rover. Upon purchase, you’ll receive points!</p>
                            </div>
                        </div>
                        <div className='flex items-center justify-center w-full'>
                            {user.referral_code && (
                                <button className='w-[20%] flex pl-[8px] pr-[12px] py-[6px] justify-center items-center gap-[6px] border-[1px] border-dotted border-[#000]'>
                                    <p className='text-[#000] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>{user.referral_code}</p>
                                </button>
                            )
                            }
                            <button className={`flex pl-[8px] pr-[12px] py-[6px] justify-center items-center gap-[6px] border-[1px] border-dotted border-[#727272] bg-[${linkColor}]`} onClick={copyToCodeHandler}>
                                <img src={CopyIcon} alt="Copy Icon" className='w-[20px] h-[20px]' />
                                <p className='text-[#F3F3F3] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Copy Shareable Link</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default NiceModal.create(ShareDiscountCouponModal);